import { SpinResponse } from '@cgs/data-access';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IGameStateMachineProvider,
} from '@cgs/machines';
import { Container } from '@cgs/wge';
import { TrifectaFreeSpinsCountComponent } from '@cgs/provider-trifecta';

export class SantaFreeSpinsComponent extends TrifectaFreeSpinsCountComponent {
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;

  constructor(container: Container) {
    super(container);

    this.gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;

    this.gameStateMachine.accelerate.entered.listen(() => this.decreaseCount());
    this.gameStateMachine.stop.entered.listen(() => this.updateCount());
    this.gameStateMachine.freeSpinsRecovery.entered.listen(() =>
      this.showFreeSpinsAndUpdateCount()
    );
    this.gameStateMachine.beginFreeSpinsPopup.leaved.listen(() =>
      this.showFreeSpinsAndUpdateCount()
    );
    this.gameStateMachine.regularSpins.entered.listen(() => this.hideFreeSpins());
  }

  private decreaseCount(): void {
    const count = this.gameStateMachine.curResponse.freeSpinsInfo?.currentFreeSpinsGroup?.count;

    if (!this.gameStateMachine.curResponse.isFreeSpins || !count) {
      return;
    }

    this.setFreeSpins(count - 1);
  }

  private showFreeSpinsAndUpdateCount(): void {
    this.showFreeSpins();
    this.updateCount();
  }

  private updateCount(): void {
    if (!this.gameStateMachine.curResponse.isFreeSpins) {
      this.setFreeSpins(0);
      return;
    }

    const count =
      this.gameStateMachine.curResponse.freeSpinsInfo?.currentFreeSpinsGroup?.count || 0;

    this.setFreeSpins(count);
  }
}
